import { render, staticRenderFns } from "./ProductCategorySection.vue?vue&type=template&id=a5b07c0a&scoped=true"
import script from "./ProductCategorySection.vue?vue&type=script&lang=js"
export * from "./ProductCategorySection.vue?vue&type=script&lang=js"
import style0 from "./ProductCategorySection.vue?vue&type=style&index=0&id=a5b07c0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b07c0a",
  null
  
)

export default component.exports